import routes from "./routes";
import globalContext from "./Contexts/GlobalContext";
import Offline from "./components/offlinecom/Offline";

import ExitConformation from "./components/exitconformation/ExitConformation";

import { useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import MessageModals from "./components/modals/MessageModals";

function App() {
  const router = useRoutes(routes);
  const [loginPhoneNumber, setLoginPhoneNumber] = useState("");
  const [addNewCarPlate, setAddNewCarPlate] = useState("");
  const [contextCategoryID, setContextCategoryID] = useState(0);
  //// toggle when new car added start ////
  const [toggleNewCar, setToggleNewCar] = useState(false);
  //// toggle when new car added end ////
  const [changeKmModalIsOpen, setChangeKmModalIsOpen] = useState(false);
  const [changeKmModalKM, setChangeKmModalKM] = useState(0);

  const [isInfoModalopen, setIsInfoModalOpen] = useState(false);

  ///---->
  const [lastPage, setLastPage] = useState("/short-terms");
  ///---->

  ///---->
  const [fireAutoF, setFireAutoF] = useState(false);
  ///---->

  document.addEventListener("contextmenu", (event) => event.preventDefault());

  //// show reapri add state start /////
  const [isRepairAdd, setIsRepairAdd] = useState(false);
  const [repairAddMessage, setRepairAddMessage] = useState("");
  const [isFirstCar, setIsFirstCar] = useState(false);
  const [isAfterAdd, setIsAfterAdd] = useState(false);
  ////  show reapri add state end /////

  //// expire message states start ////
  const [isExpMessageShow, setIsExpMessageShow] = useState(false);
  //// expire message states end ////

  //// error numbers states start ////
  const [shortErrors, setShortErrors] = useState(0);
  const [midErrors, setMidErrors] = useState(0);
  const [longErrors, setLongErrors] = useState(0);
  //// error numbers states end ////

  //// infoOpen state start ////
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  //// infoOpen state end ////

  //// exit modal sec ////
  const [isExitModalOpen, setIsExitModalOpen] = useState(false);
  //// exit modal sec ////

  /// toast start ///
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  /// toast end ///

  const [status, setStatus] = useState(() => {
    if (navigator.onLine) {
      return true;
    } else {
      return false;
    }
  });
  useEffect(() => {
    window.ononline = (e) => {
      setStatus(true);
    };
    window.onoffline = (e) => {
      setStatus(false);
    };
  }, [status]);

  const [rlp, setRlp] = useState(false);

  document.addEventListener("click", () => {
    setIsInfoOpen(false);
  });

  return (
    <>
      <globalContext.Provider
        value={{
          loginPhoneNumber,
          setLoginPhoneNumber,
          addNewCarPlate,
          setAddNewCarPlate,
          contextCategoryID,
          setContextCategoryID,
          toggleNewCar,
          setToggleNewCar,
          changeKmModalIsOpen,
          setChangeKmModalIsOpen,
          changeKmModalKM,
          setChangeKmModalKM,
          lastPage,
          setLastPage,
          fireAutoF,
          setFireAutoF,
          isRepairAdd,
          setIsRepairAdd,
          repairAddMessage,
          setRepairAddMessage,
          isFirstCar,
          setIsFirstCar,
          isAfterAdd,
          setIsAfterAdd,
          isExpMessageShow,
          setIsExpMessageShow,
          isInfoModalopen,
          setIsInfoModalOpen,
          rlp,
          setRlp,
          shortErrors,
          setShortErrors,
          midErrors,
          setMidErrors,
          longErrors,
          setLongErrors,
          isInfoOpen,
          setIsInfoOpen,
          isExitModalOpen,
          setIsExitModalOpen,
          isToastOpen,
          setIsToastOpen,
          toastMessage,
          setToastMessage,
        }}
      >
        {!status ? (
          <>
            <Offline setStatus={setStatus} />
          </>
        ) : (
          <>
            {isExitModalOpen && <ExitConformation />}
            {router}
          </>
        )}
      </globalContext.Provider>
    </>
  );
}

export default App;
